import { render } from "./AppFooter.vue?vue&type=template&id=a22a2ba8&scoped=true"
const script = {}

import "./AppFooter.vue?vue&type=style&index=0&id=a22a2ba8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22a2ba8"]])

export default __exports__